{
  "app": {
    "notFound": {
      "title": "This could not be found",
      "body": "It may have been removed, or the link is out of date.",
      "backTo": "Back to {list}"
    },
    "name": "Taler",
    "foundation": "Foundation",
    "foundationBody": "The workspace, boundaries, contract client, domain primitives, tokens and mock server are in place. Product screens are built on top of this.",
    "signedInAs": "Signed in as",
    "ledgers": "Ledgers",
    "activeLedger": "Active ledger",
    "loading": "Loading",
    "role": "Role",
    "archived": "Archived",
    "searchLedgers": "Search ledgers",
    "noLedgersFound": "No ledgers found"
  },
  "auth": {
    "notProvisionedTitle": "Your account is not set up in Taler",
    "notProvisionedBody": "You signed in successfully, but this installation has no account for you. Ask an administrator to add you.",
    "signInTitle": "Sign in to Taler",
    "signInBody": "Taler uses your Google account. You will be taken to Google and returned here.",
    "signInAction": "Continue with Google",
    "devSignInAction": "Sign in as {email} (dev only)",
    "signInDeclined": "Sign-in was cancelled. Nothing was changed.",
    "callbackTitle": "Signing you in",
    "callbackFailedTitle": "Sign-in could not be completed",
    "callbackFailedBody": "The sign-in could not be finished. Start again from the sign-in page.",
    "signOut": "Sign out"
  },
  "shell": {
    "primaryNav": "Primary",
    "noNavigation": "No sections are available for your role in this ledger.",
    "navGroupInsight": "Insight",
    "navGroupShared": "Shared ledgers",
    "dismissNotification": "Dismiss notification",
    "skipToContent": "Skip to content",
    "offline": "You are offline. Showing the data you last loaded; changes cannot be saved until you reconnect.",
    "version": "Version",
    "collapseSidebar": "Collapse sidebar",
    "expandSidebar": "Expand sidebar",
    "noLedger": "No ledger selected",
    "language": "Language",
    "account": "Account",
    "createLedger": {
      "action": "Create ledger",
      "title": "Create a ledger",
      "description": "A ledger is a separate set of books, for example for a household or a company. You become its owner.",
      "name": "Ledger name",
      "template": "Start with",
      "templates": {
        "PERSONAL": "Personal accounts",
        "COMPANY": "Company accounts",
        "SHARED": "Shared household accounts"
      },
      "submit": "Create ledger",
      "cancel": "Cancel",
      "error": "The ledger could not be created. Try again."
    },
    "accountingView": "Advanced accounting details",
    "accountingViewHint": "Show debits, credits and raw account codes",
    "displayCurrency": "Display currency",
    "searchCurrencies": "Search currencies",
    "noCurrenciesFound": "No currencies found"
  },
  "transactions": {
    "title": "Transactions",
    "loading": "Loading transactions",
    "loadMore": "Load more",
    "loadingMore": "Loading more",
    "endOfList": "You've reached the beginning of the ledger.",
    "emptyTitle": "No transactions yet",
    "emptyBody": "Record your first transaction to start this ledger's history.",
    "emptyFilteredTitle": "No transactions match these filters",
    "emptyFilteredBody": "Try widening the date range or clearing a filter.",
    "errorTitle": "Transactions could not be loaded",
    "errorBody": "Something went wrong while reading the ledger. Try again.",
    "retry": "Try again",
    "reversed": "Reversed",
    "noLedger": "No ledger is available for your account yet.",
    "noAccess": "You do not have permission to view this ledger's transactions.",
    "date": "Date",
    "description": "Description",
    "expense": "Expense",
    "income": "Income",
    "transfer": "Transfer",
    "noKind": "No kind",
    "noDescription": "No description",
    "transferTo": "to",
    "source": {
      "MANUAL": "entered by hand",
      "IMPORT": "import",
      "RECEIPT": "receipt",
      "CHECKUP": "checkup",
      "SYSTEM": "system",
      "SCHEDULED": "scheduled",
      "TRANSFER": "transfer",
      "ACCOUNT_CLOSE": "account close",
      "LOAN": "loan",
      "FX_REVALUATION": "exchange-rate revaluation",
      "CROSS_LEDGER_FORGIVE": "ledger debt forgiven",
      "CONTACT_FORGIVE": "contact receivable forgiven"
    },
    "filters": {
      "search": "Search",
      "searchPlaceholder": "Search payee, memo, notes...",
      "from": "From",
      "until": "Until",
      "account": "Account",
      "allAccounts": "All accounts",
      "searchAccounts": "Search accounts",
      "noAccountsFound": "No accounts found",
      "merchant": "Merchant",
      "tags": "Tags",
      "allTags": "All tags",
      "searchTags": "Search tags",
      "noTagsFound": "No tags found",
      "tagsHint": "Tags (matches any selected)",
      "tagsSeparator": " or ",
      "kind": "Kind",
      "source": "Source",
      "allSources": "All sources",
      "minAmount": "Min amount",
      "maxAmount": "Max amount",
      "reset": "Clear filters",
      "removeFilter": "Remove {label} filter",
      "region": "Filter transactions",
      "anyKind": "All",
      "date": "Date",
      "amount": "Amount",
      "moreFilters": "More filters"
    },
    "tableRegion": "Transactions table, scrollable",
    "moreActions": "More actions",
    "splitExpense": "Split expense",
    "scanReceipt": "Scan receipt",
    "importCsv": "Import CSV",
    "groupByDay": "Group by day",
    "groupByDayHint": "One header per day, with that day's subtotals",
    "groupEntryCountOne": "1 entry",
    "groupEntryCount": "{count} entries",
    "groupEntryCountPartial": "{count}+ entries",
    "groupSubtotalsPending": "Subtotals available once the rest of this day loads",
    "noRateForDate": "No exchange rate for this date",
    "transferSubtotalHint": "Total moved by transfers that day - a magnitude, not a signed net",
    "crossLedgerTransfer": "Cross-ledger transfer",
    "rateToBase": "rate to ledger base {rate}",
    "crossLedgerLink": {
      "to": "To {ledger}",
      "from": "From {ledger}"
    },
    "detail": {
      "label": "Entry details",
      "title": "Entry",
      "close": "Close",
      "loading": "Loading entry",
      "errorTitle": "This entry could not be loaded",
      "postingsTitle": "Postings",
      "residualBadge": "Added automatically",
      "residualExplanation": "The server added this posting for the exchange rate difference between currencies. It is not something you entered.",
      "editAction": "Edit",
      "saveAction": "Save changes",
      "saving": "Saving",
      "cancelEdit": "Cancel",
      "discardTitle": "Discard changes?",
      "discardConsequence": "Your edits to this entry have not been saved.",
      "keepEditing": "Keep editing",
      "discardAction": "Discard changes",
      "dateLabel": "Date",
      "payeeLabel": "Payee",
      "memoLabel": "Memo",
      "notesLabel": "Notes",
      "tagsLabel": "Tags (comma-separated)",
      "postingsEditTitle": "Postings",
      "accountLabel": "Account",
      "amountLabel": "Amount",
      "currencyLabel": "Currency",
      "postingMemoLabel": "Memo (optional)",
      "addPosting": "Add posting",
      "removePosting": "Remove",
      "pendingRetry": "Still processing the previous attempt - try again in a moment.",
      "reverseTitle": "Reverse this entry",
      "reverseConsequence": "Reversing posts a new entry with every amount flipped, dated today. This entry stays exactly as it is - reversing erases nothing, and both entries stay visible in the list.",
      "reverseAction": "Reverse entry",
      "reversing": "Reversing",
      "deleteTitle": "Delete this entry",
      "deleteConsequence": "Deleting removes this entry and its postings permanently and cannot be undone. If you want the history to stay visible, reverse it instead.",
      "deleteAction": "Delete entry",
      "deleting": "Deleting",
      "plainTitle": "Where the money went",
      "plain": {
        "spentOn": "Spent on",
        "earnedFrom": "Earned from",
        "paidFrom": "Paid from",
        "paidInto": "Paid into",
        "movedFrom": "Moved from",
        "movedTo": "Moved to"
      },
      "detailsTitle": "Details",
      "dateRequired": "Choose a date.",
      "memoRequired": "Enter a memo.",
      "accountRequired": "Choose an account.",
      "amountRequired": "Enter an amount.",
      "currencyInvalid": "Enter a three-letter currency code.",
      "revaluation": {
        "changesTitle": "Gain / loss",
        "noMoneyMoved": "Valuation only, no money moved"
      },
      "createdLabel": "Created",
      "modifiedLabel": "Modified",
      "typeLabel": "Type"
    },
    "entry": "Entry",
    "summary": "Summary",
    "effects": "Effects",
    "summaryMore": "+{count} more",
    "rowActions": "Actions for {entry}",
    "openAction": "Open",
    "actions": "Actions",
    "effectsOtherCurrencies": "+{count} in other currencies",
    "revaluation": {
      "title": "Exchange-rate revaluation"
    },
    "subtitle": "All your financial activity in one place."
  },
  "contacts": {
    "title": "Contacts",
    "loading": "Loading contacts",
    "emptyTitle": "No contacts yet",
    "emptyBody": "Add a contact to start tracking what you owe each other.",
    "errorTitle": "Contacts could not be loaded",
    "detailErrorTitle": "This contact could not be loaded",
    "errorBody": "Something went wrong while reading the contact directory. Try again.",
    "retry": "Try again",
    "noLedger": "No ledger is available for your account yet.",
    "noAccess": "You do not have permission to view this ledger's contacts.",
    "name": "Name",
    "since": "Contact since",
    "addContact": "Add contact",
    "nameLabel": "Name",
    "notesLabel": "Notes (optional)",
    "save": "Save",
    "saving": "Saving",
    "cancel": "Cancel",
    "createErrorBody": "The contact could not be created. Try again.",
    "editAction": "Edit",
    "updateErrorBody": "The contact could not be saved. Try again.",
    "balances": "Balances",
    "netBalance": "Net balance",
    "netBalanceExplain": "Amount they owe you (positive) or you owe them (negative).",
    "owesYou": "They owe you",
    "youOwe": "You owe them",
    "settled": "Settled",
    "notes": "Notes",
    "notesEmpty": "No notes yet.",
    "deleteTitle": "Delete contact",
    "deleteConfirmTitle": "Delete {name}?",
    "deleteConsequence": "Deleting removes this contact from your directory. Entries that already reference it are not affected: its account is archived, not deleted, so your history stays intact.",
    "deleteBlockedByBalance": "This contact still has a balance in at least one currency. Forgive what they owe you, or record a repayment, until every currency is settled.",
    "deleteAction": "Delete contact",
    "deleting": "Deleting",
    "deleteErrorBody": "The contact could not be deleted. Try again.",
    "deleteDenied": "Only the ledger owner can delete contacts.",
    "deleted": "Contact deleted.",
    "historyTitle": "Transactions",
    "historyEmptyTitle": "No transactions with this contact yet",
    "historyEmptyBody": "Entries that involve this contact appear here.",
    "historyOwnTitle": "Your entries with this contact",
    "historyOwnEmptyTitle": "You have no entries with this contact yet",
    "historyOwnEmptyBody": "Entries you can see that involve this contact appear here.",
    "historyErrorTitle": "Transactions could not be loaded",
    "historyErrorBody": "Something went wrong while reading this contact's entries. Try again.",
    "payback": {
      "action": "Record repayment",
      "title": "Record repayment",
      "close": "Close",
      "directionLabel": "Direction",
      "theyPaidMe": "They paid me",
      "iPaidThem": "I paid them",
      "moneyAccountLabel": "Money account",
      "amountLabel": "Amount",
      "currencyLabel": "Currency",
      "currencyPlaceholder": "—",
      "currencyHint": "The currency follows the selected money account.",
      "dateLabel": "Date",
      "memoLabel": "Memo",
      "memoDefault": "Repayment - {name}",
      "cancel": "Cancel",
      "save": "Record repayment",
      "saving": "Recording",
      "accountRequired": "Choose a money account.",
      "amountRequired": "Enter an amount greater than zero.",
      "dateRequired": "Choose a date.",
      "memoRequired": "Enter a memo.",
      "saveError": "The repayment could not be recorded. Try again.",
      "success": "Repayment recorded.",
      "discardTitle": "Discard this repayment?",
      "discardConsequence": "Your unsaved repayment details will be lost.",
      "keepEditing": "Keep editing",
      "discardAction": "Discard"
    },
    "searchLabel": "Search contacts",
    "searchPlaceholder": "Search by name",
    "sortLabel": "Sort contacts",
    "sort": {
      "name-asc": "Name A–Z",
      "name-desc": "Name Z–A",
      "since-newest": "Newest first",
      "since-oldest": "Oldest first"
    },
    "noMatches": "No contacts match your search.",
    "rowActionsHeading": "Actions",
    "rowActions": "Actions for {name}",
    "openAction": "Open contact",
    "subtitle": "People you transact with.",
    "addContactTitle": "Add contact",
    "namePlaceholder": "e.g. Adam",
    "notesPlaceholder": "Friend, family, roommate…",
    "forgiveAction": "Forgive debt",
    "forgiven": "Debt forgiven.",
    "nothingToForgive": "{name} owes you nothing to forgive."
  },
  "accounts": {
    "title": "Accounts",
    "subtitle": "All your accounts, balances and activity.",
    "moreActions": "More actions",
    "tableLabel": "Chart of accounts",
    "loading": "Loading accounts",
    "errorTitle": "Accounts could not be loaded",
    "errorBody": "Something went wrong while reading the chart of accounts. Try again.",
    "retry": "Try again",
    "empty": "No accounts yet",
    "noLedger": "No ledger is available for your account yet.",
    "noAccess": "You do not have permission to view this ledger's accounts.",
    "showArchived": "Show archived accounts",
    "showHidden": "Show hidden accounts",
    "detailsLabel": "Account details",
    "archived": "Archived",
    "archivedNote": "This account is archived.",
    "hidden": "Hidden",
    "hiddenNote": "This account is hidden from ordinary lists.",
    "hideAction": "Hide",
    "unhideAction": "Unhide",
    "systemAccountNote": "This account is managed by the system and cannot be renamed.",
    "accountClass": "Class",
    "type": "Type",
    "currency": "Currency",
    "noCurrency": "No currency",
    "notPostableNote": "This account has sub-accounts, so postings go to those instead.",
    "postableNote": "No sub-accounts — postings can go directly to this account.",
    "makeDefault": "Make default",
    "defaultAccountNote": "Your default account: the split-expense screen pays from it.",
    "addAccount": "Add account",
    "addSubAccount": "Add sub-account",
    "editAccount": "Edit account",
    "editAction": "Edit",
    "presetColors": "Preset colours",
    "iconNames": {
      "BANK": "Bank",
      "CASH": "Cash",
      "CARD": "Card",
      "WALLET": "Wallet",
      "CHART": "Chart",
      "SAVINGS": "Savings",
      "INVESTMENT": "Investment",
      "CRYPTO": "Crypto",
      "HOME": "Home",
      "SHOPPING": "Shopping",
      "GIFT": "Gift",
      "GLOBAL": "Global"
    },
    "archiveAction": "Archive",
    "restoreAction": "Restore",
    "archiveConfirmPrompt": "Archive this account?",
    "archiveFailed": "Archive could not be saved. Try again.",
    "restoreFailed": "Restore could not be saved. Try again.",
    "reconcileFailed": "Reconciliation could not be started. Try again.",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "code": "Code",
    "names": "Name",
    "nameEn": "English",
    "nameHu": "Hungarian",
    "icon": "Icon",
    "color": "Colour",
    "parentAccount": "Parent account",
    "create": "Create",
    "creating": "Creating",
    "update": "Save",
    "updating": "Saving",
    "codeAlreadyUsed": "This code is already used in this ledger.",
    "missingLocaleError": "Both English and Hungarian names are required.",
    "createErrorGeneral": "The account could not be created. Try again.",
    "updateErrorGeneral": "The account could not be updated. Try again.",
    "reconcileTitle": "Reconcile",
    "reconcileHistoryTitle": "Reconciliation history",
    "reconcileLoadingHistory": "Loading reconciliation history…",
    "reconcileHistoryError": "Reconciliation history could not be loaded.",
    "reconcileHistoryEmpty": "No reconciliations yet.",
    "reconcileOutcomeMatched": "Balances matched",
    "reconcileOutcomeCorrected": "Correction posted",
    "reconcileOutcomeReversed": "Correction reversed",
    "reconcileViewEntry": "View entry",
    "columnAccount": "Account",
    "holdsColumn": "Own currency",
    "columnBalance": "Balance",
    "accountCount": "{count} accounts",
    "subAccountCount": "{count} sub-account | {count} sub-accounts",
    "searchLabel": "Search accounts",
    "searchPlaceholder": "Search accounts by name or code",
    "allClasses": "All classes",
    "allTypes": "All types",
    "classTotals": "Balance summary",
    "reconcileAccounts": "Reconcile accounts",
    "resumeReconciliation": "Resume reconciliation",
    "reconciliationOpenBanner": "A reconciliation is in progress ({count} accounts checked so far).",
    "reconcileViewSession": "View session",
    "kind": "Kind of account",
    "kinds": {
      "bank": "Bank account",
      "cash": "Cash",
      "savings": "Savings",
      "investments": "Investments",
      "crypto": "Crypto",
      "creditCard": "Credit card",
      "expense": "Expense category",
      "income": "Income category"
    },
    "nameRequired": "Enter a name for the account.",
    "codeRequired": "Enter a code.",
    "advanced": "Advanced",
    "simpleMode": "Simple",
    "classes": {
      "ASSET": "Assets",
      "LIABILITY": "Liabilities",
      "INCOME": "Income",
      "EXPENSE": "Expenses",
      "EQUITY": "Equity"
    },
    "types": {
      "CASH": "Cash",
      "SAVINGS": "Savings",
      "STOCKS": "Stocks",
      "CRYPTO": "Crypto",
      "BROKER_CASH": "Broker cash",
      "FX": "Foreign exchange",
      "EMERGENCY_FUND": "Emergency fund",
      "CONTACT": "Contact",
      "LOAN": "Loan",
      "INTEREST": "Interest",
      "FEE": "Fee",
      "OPENING": "Opening balance",
      "RECONCILIATION": "Reconciliation",
      "PNL": "Profit and loss",
      "OTHER": "General"
    },
    "groupToggle": "Group of accounts",
    "groupHint": "Holds other accounts, such as several accounts under one bank. You add them next.",
    "chooseCurrency": "Choose a currency",
    "currencyRequired": "Choose a currency for this account.",
    "parentRequired": "Choose where this account goes.",
    "columnType": "Type",
    "groupBadge": "Group",
    "groupNote": "This is a group: it holds other accounts and cannot be posted to itself.",
    "errors": {
      "parent_required": "Choose where this account goes.",
      "parent_class_mismatch": "The account and its parent must be the same kind: assets under assets, expenses under expenses and so on.",
      "parent_not_allowed": "Accounts cannot be added under this account. Choose a group instead.",
      "parent_archived": "That parent account is archived. Restore it or choose another.",
      "parent_not_found": "That parent account no longer exists. Choose another.",
      "group_class_not_allowed": "Only asset and liability accounts can be groups.",
      "code_must_extend_parent": "The code must start with the parent account's code.",
      "type_not_allowed_for_class": "This type is not available for that kind of account.",
      "currency_not_supported": "This currency is not supported in this installation."
    },
    "openAccountPage": "Open {name}",
    "actionsLabel": "Actions for {name}",
    "openAction": "Open",
    "columnActions": "Actions"
  },
  "membership": {
    "title": "Members",
    "loading": "Loading members",
    "noLedger": "No ledger is available for your account yet.",
    "noAccess": "You do not have permission to manage this ledger's members.",
    "errorTitle": "Members could not be loaded",
    "errorBody": "Something went wrong while reading membership. Try again.",
    "retry": "Try again",
    "membersTitle": "Members",
    "membersEmpty": "No members yet.",
    "subject": "Email",
    "role": "Role",
    "addMemberTitle": "Add a member directly",
    "addMemberBody": "Use this for someone who already has a Taler account. They get access immediately, with no invitation step.",
    "addMemberAction": "Add member",
    "addMemberError": "Could not add this member. Check the email and try again.",
    "invitationsTitle": "Invitations",
    "invitationsEmpty": "No invitations yet.",
    "invitedSubject": "Email",
    "status": "Status",
    "expiresAt": "Expires",
    "statusPending": "Pending",
    "statusAccepted": "Accepted",
    "statusRevoked": "Revoked",
    "revoke": "Revoke",
    "revokeConfirmBody": "The link already sent to them stops working immediately. This cannot be undone.",
    "revokeConfirmAction": "Revoke invitation",
    "revokeCancel": "Cancel",
    "revokeError": "Could not revoke this invitation. Try again.",
    "inviteTitle": "Invite someone new",
    "inviteBody": "Send a link by email. They accept it to join, and the role you choose here is granted the moment they do.",
    "inviteAction": "Send invitation",
    "inviteError": "Could not send this invitation. Check the email and try again.",
    "roleDescription": {
      "OWNER": "Full control of this ledger, including membership, settings and the account archive.",
      "PARTNER": "Everything except managing membership, ledger settings and the account archive.",
      "OBSERVER": "Read-only access to every entry, account name and balance.",
      "AGGREGATES_VIEWER": "The dashboard's aggregate figures only - no entries, no balances.",
      "CONTRIBUTOR": "Creates entries and sees only their own - no balances, no dashboard, no aggregates."
    },
    "remove": "Remove",
    "removeConfirmBody": "{subject} loses access to this ledger immediately. Their entries stay in the journal, still attributed to them. This cannot be undone.",
    "removeConfirmAction": "Remove member",
    "removeCancel": "Cancel",
    "removeError": "Could not remove this member. Try again.",
    "changeRoleError": "Could not change this member's role. Try again.",
    "lastOwnerNote": "The only owner of this ledger. Add another owner before removing or changing this role.",
    "roleName": {
      "OWNER": "Owner",
      "PARTNER": "Partner",
      "OBSERVER": "Viewer",
      "AGGREGATES_VIEWER": "Totals only",
      "CONTRIBUTOR": "Contributor"
    },
    "roleFor": "Role for {subject}"
  },
  "invitationAccept": {
    "title": "Ledger invitation",
    "body": "You've been invited to join a Taler ledger. Accepting may first ask you to sign in.",
    "acceptAction": "Accept invitation",
    "accepting": "Accepting invitation",
    "successTitle": "Invitation accepted",
    "successBody": "You now have {role} access to this ledger.",
    "continueAction": "Go to the ledger",
    "errorTitle": "This invitation could not be accepted",
    "errorBody": "The link may have expired, already been used, or been revoked. Ask whoever invited you to send a new one."
  },
  "entries": {
    "title": "New entries",
    "backToTransactions": "Back to transactions",
    "noLedger": "No ledger is available for your account yet.",
    "noAccess": "You do not have permission to post entries to this ledger.",
    "tab": {
      "expense": "Expense",
      "income": "Income",
      "transfer": "Between my accounts",
      "other": "Other"
    },
    "date": "Date",
    "amount": "Amount",
    "memo": "Memo",
    "payee": "Payee",
    "tags": "Tags",
    "removeTag": "Remove tag {tag}",
    "tagUsageCount": "{count}×",
    "rowActions": "Row actions",
    "accountLabel": {
      "EXPENSE": "Account",
      "INCOME": "Account",
      "TRANSFER": "From account"
    },
    "counterLabel": {
      "EXPENSE": "Category",
      "INCOME": "Source",
      "TRANSFER": "To account"
    },
    "addRow": "Add another entry",
    "shortcutEnter": "Enter",
    "addRowHint": "Press {key} in a completed row to start the next entry.",
    "addSplit": "+ Split",
    "removeRow": "Remove row",
    "removeSplit": "Remove split",
    "currencyMismatch": "This account only accepts a different currency than the row's own.",
    "splitTotal": "Split total",
    "deltaFor": "Change to {account}",
    "deltaHint": "This is the change the batch makes to each account, not the resulting balance - the database checks the real balance when you post, and a negative one is a normal fact, not an error.",
    "submitErrorGeneric": "Something went wrong while posting. Try again.",
    "posting": "Posting…",
    "postOne": "Post 1 entry",
    "postCount": "Post {count} entries",
    "noCompleteRows": "Fill in a row to post it.",
    "mostUsed": "Most used in this ledger",
    "pickerFavourite": "Favourite",
    "pickerRecent": "Most used",
    "pickerAccounts": "Accounts",
    "pickerCategories": "Categories",
    "pickerContacts": "Contacts",
    "pickerTransferAccounts": "Accounts",
    "pickerNoMatches": "No matching account",
    "pickerPlaceholder": "Choose an account",
    "pickerSearchHint": "Type to search",
    "pickerCurrencyOnly": "Holds {currency} only",
    "pickerNotAvailable": "Not available here",
    "pickerCreateContact": "Create contact \"{name}\"",
    "pickerUseExisting": "Use existing contact \"{name}\"",
    "pickerNewContact": "New contact",
    "pickerCreating": "Creating contact…",
    "pickerCreateFailed": "Could not create the contact. Try again.",
    "newContactTitle": "New contact",
    "newContactNotes": "Notes (optional)",
    "everythingElse": "Everything else that matches",
    "frecencyToday": "today",
    "frecencyYesterday": "yesterday",
    "frecencyDaysAgo": "{count} days ago",
    "frecencyCount": "{count}×",
    "frecencyCountWhen": "{count}× · {when}",
    "postingAccount": "Account",
    "signedAmount": "Signed amount",
    "addLine": "+ Add line",
    "balance": "Balance",
    "notBalanced": "Postings must sum to zero before this can post.",
    "postEntry": "Post entry",
    "posted": "Posted",
    "thisBatch": "This batch",
    "thisEntry": "This entry",
    "readyCount": "{count} ready to post",
    "alreadyInLedger": "Already in the ledger",
    "alreadyInLedgerUnavailable": "Recent entries could not be loaded.",
    "needsDetailsCount": "{count} waiting for details",
    "blockedCount": "{count} cannot be posted",
    "incompleteCount": "{count} not filled in",
    "batchWaits": "{waiting}. The batch posts once every row is ready.",
    "extension": {
      "notCarried": "{label}: not recorded",
      "splitsNotCarried": "{label} cannot be split - remove the extra lines.",
      "details": "Details",
      "closeDetails": "Close details",
      "attachFailed": "The entry posted, but {label} was not saved: {detail}",
      "retry": "Retry",
      "notCarriedShort": "Not recorded"
    },
    "fx": {
      "label": "Currency exchange",
      "needsReceived": "Enter the amount received in {currency}",
      "receivedLabel": "Received",
      "impliedRate": "implied rate {rate}",
      "receivedAriaLabel": "Received ({currency})"
    }
  },
  "splitExpense": {
    "title": "Split expense",
    "subtitle": "Break one receipt into lines, and send each line to a category or a person.",
    "date": "Date",
    "paidFrom": "Paid from",
    "payee": "Merchant",
    "total": "Receipt total",
    "remaining": "Remaining to allocate",
    "remainingShort": "The lines don't add up to the total yet.",
    "remainingOver": "The lines add up to more than the total.",
    "splitEvenly": "Split evenly",
    "setAllCategory": "Category",
    "applyToAll": "Apply to all",
    "targetColumn": "Category / Contact",
    "addLine": "+ Add line",
    "submit": "Split receipt",
    "posting": "Posting…",
    "posted": "Receipt split",
    "notBalanced": "The lines must add up to the receipt total before this can post."
  },
  "paymentAccount": {
    "field": "Payment account",
    "gateExplanation": "Choose the account split-expense entries in this ledger are paid from. This is set once and used for every line - you can change it later on the Accounts page with \"Make default\".",
    "change": "Change",
    "save": "Save",
    "saving": "Saving…"
  },
  "exports": {
    "title": "Exports",
    "noLedger": "No ledger is available for your account yet.",
    "noAccess": "You do not have permission to export this ledger's transactions.",
    "fromDate": "From",
    "untilDate": "Until",
    "request": "Request export",
    "requesting": "Requesting…",
    "invalidRange": "The start date must be on or before the end date.",
    "createError": "The export could not be requested. Try again.",
    "loading": "Loading exports",
    "errorTitle": "Exports could not be loaded",
    "errorBody": "Something went wrong while reading your export history. Try again.",
    "retry": "Try again",
    "emptyTitle": "No exports yet",
    "emptyBody": "Request an export of a date range to download it as a CSV file.",
    "requested": "Requested",
    "range": "Range",
    "requestedBy": "Requested by",
    "actions": "Actions",
    "download": "Download",
    "downloading": "Downloading…",
    "unknownError": "The export failed for an unknown reason.",
    "tableRegion": "Exports table, scrollable",
    "status": {
      "label": "Status",
      "QUEUED": "Queued",
      "RUNNING": "Generating…",
      "COMPLETED": "Completed",
      "FAILED": "Failed"
    }
  },
  "merchants": {
    "title": "Merchants",
    "name": "Name",
    "firstSeen": "First seen",
    "searchLabel": "Search merchants",
    "searchPlaceholder": "Search merchants…",
    "noLedger": "No ledger is available for your account yet.",
    "noAccess": "You do not have permission to view this ledger's merchants.",
    "loadError": "Merchants could not be loaded.",
    "retry": "Try again",
    "emptyState": "Merchants will appear here once a journal entry names one.",
    "noResults": "No merchants match your search.",
    "loadMore": "Load more",
    "loadingMore": "Loading…",
    "aliases": "Aliases",
    "aliasesToggleShow": "Show aliases",
    "aliasesToggleHide": "Hide aliases",
    "aliasesEmpty": "No aliases yet.",
    "aliasAdd": "Add alias",
    "aliasPlaceholder": "Alias",
    "aliasAdding": "Adding…",
    "aliasRemove": "Remove alias {alias}",
    "aliasRemoveConfirm": "Remove {alias}?",
    "aliasRemoveConfirmYes": "Remove",
    "aliasRemoveConfirmCancel": "Cancel",
    "aliasRemoving": "Removing…",
    "aliasErrorAlreadyExists": "This is already an alias of {name}.",
    "aliasErrorCollides": "This name already belongs to another merchant.",
    "aliasErrorGeneric": "The alias could not be added.",
    "merge": "Merge",
    "mergeInto": "Merge {name} into…",
    "mergeDestinationLabel": "Merge into",
    "mergeDestinationPlaceholder": "Choose a merchant",
    "mergeDestinationSearchLabel": "Search merchants",
    "mergeDestinationEmpty": "No other merchants match.",
    "mergeCounting": "Counting entries…",
    "mergeCountError": "The entry count could not be determined. Try again before merging.",
    "mergeConsequenceOne": "This moves 1 entry from {source} into {destination} and deletes {source}. This cannot be undone.",
    "mergeConsequenceMany": "This moves {count} entries from {source} into {destination} and deletes {source}. This cannot be undone.",
    "mergeConsequenceNone": "This deletes {source} and carries its name forward as an alias of {destination}. This cannot be undone.",
    "mergeContinue": "Continue",
    "mergeBack": "Back",
    "mergeConfirm": "Merge merchants",
    "mergeConfirmAction": "Merge and delete {source}",
    "mergeCancel": "Cancel",
    "mergeSubmitting": "Merging…",
    "mergeError": "The merge could not be completed.",
    "mergeSuccess": "{source} was merged into {destination}."
  },
  "dashboard": {
    "title": "Home",
    "loading": "Loading home",
    "noLedger": "No ledger is available for your account yet.",
    "noAccess": "You do not have permission to view this ledger's home screen.",
    "errorTitle": "Home could not be loaded",
    "errorBody": "Something went wrong while reading home. Try again.",
    "panelErrorTitle": "This part of Home could not be loaded",
    "retry": "Try again",
    "netWorth": "Net worth",
    "cash": "Cash",
    "totalLent": "Total lent",
    "totalBorrowed": "Total borrowed",
    "refresh": "Refresh",
    "income": "Income this month",
    "expense": "Spending this month",
    "thisMonth": "Month to date",
    "incomeShort": "Income",
    "expenseShort": "Spending",
    "netResult": "Net result this month",
    "netResultShort": "Net",
    "windowRange": "{from} to {until}",
    "comparedWith": "{current}, compared with {previous}",
    "vsSamePointLastMonth": "vs same point last month",
    "headlineOkay": "You're doing okay",
    "headlineBehind": "You're behind last month",
    "savingsRate": "Savings rate",
    "savingsRateBefore": "Same point last month: {rate}",
    "noSavingsRate": "No savings rate without income",
    "saved": "Saved",
    "spent": "Spent",
    "cashFlow": "Cash flow",
    "spending": "Spending by category",
    "noSpending": "No spending in this window.",
    "otherCategory": "Other",
    "accountMovement": "Account movement",
    "account": "Account",
    "moneyIn": "Money in",
    "moneyOut": "Money out",
    "transfers": "Transfers",
    "noAccountMovement": "No account movement in this window.",
    "recentTransactions": "Recent transactions",
    "netWorthHistoryTitle": "Cash and net worth, full history",
    "netWorthHistoryLabel": "Net worth and cash from {from} to {to}: net worth went from {fromValue} to {toValue}",
    "netWorthHistoryResolutionDaily": "One point per day",
    "netWorthHistoryResolution": "One point every {days} days"
  },
  "transfers": {
    "inboxTitle": "Inbox",
    "inboxSubtitle": "Requests and activity from your connected ledgers.",
    "inboxLoading": "Loading pending transfers",
    "inboxErrorTitle": "Pending transfers could not be loaded",
    "inboxErrorBody": "Something went wrong while reading the inbox. Try again.",
    "inboxEmptyTitle": "Nothing pending",
    "inboxEmptyBody": "Transfers other ledgers send you will wait here for your decision.",
    "inboxEmptyRelationshipHint": "A ledger can only send you transfers once you have a relationship with it.",
    "inboxEmptyRelationshipLink": "Manage relationships",
    "retry": "Try again",
    "noAccess": "You do not have permission to view transfers for this ledger.",
    "noLedger": "No ledger is available for your account yet.",
    "depositInto": "Deposit into",
    "theChosenAccount": "the account you choose",
    "acceptConsequence": "Accepting posts {amount} into {account} in this ledger. This cannot be undone.",
    "accept": "Accept",
    "rejectConsequence": "Rejecting cancels the transfer; {ledger} keeps the money. This cannot be undone.",
    "reject": "Reject",
    "cancel": "Cancel",
    "fxLeg": "sent as {amount}",
    "impliedRate": "implied rate {rate}",
    "recentlyAcceptedTitle": "Recently accepted",
    "reverseConsequence": "Reversing posts an offsetting entry in both ledgers. This cannot be undone.",
    "reverse": "Reverse",
    "fromLedger": "From {ledger}",
    "extension": {
      "label": "Cross-ledger · {ledger}",
      "bothForeignBlocked": "Choose an account in this ledger for at least one side.",
      "needsTargetAmount": "Enter the amount received in {currency}",
      "targetAmountLabel": "They receive",
      "targetAmountAriaLabel": "Amount received ({currency})",
      "proposedToast": "Sent to {ledger} - waiting for them to accept."
    }
  },
  "loans": {
    "title": "Loans",
    "loading": "Loading loans",
    "emptyTitle": "No loans yet",
    "emptyBody": "Add a loan to start tracking its principal, interest and payments.",
    "errorTitle": "Loans could not be loaded",
    "detailErrorTitle": "This loan could not be loaded",
    "errorBody": "Something went wrong while reading the loan. Try again.",
    "retry": "Try again",
    "noLedger": "No ledger is available for your account yet.",
    "noAccess": "You do not have permission to view this ledger's loans.",
    "name": "Name",
    "addLoan": "Add loan",
    "nameLabel": "Name",
    "currency": "Currency",
    "selectCurrency": "Select a currency",
    "originalPrincipal": "Amount borrowed",
    "outstandingPrincipal": "Still owed (excluding interest)",
    "remainingBalance": "Remaining balance",
    "accruedInterest": "Accrued interest",
    "annualInterestRate": "Annual interest rate",
    "drawdownDate": "Date received",
    "nextAccrualDate": "Next interest date",
    "accrualCount": "Interest postings so far",
    "save": "Save",
    "saving": "Saving",
    "cancel": "Cancel",
    "invalidAmount": "Check the amount and rate: they must be plain decimal numbers.",
    "invalidInterestRate": "Enter an interest rate between 0 and 100.",
    "createErrorBody": "The loan could not be created. Try again.",
    "paymentHistory": "Payment history",
    "noPayments": "No payments recorded yet.",
    "paymentDate": "Date",
    "paymentAmount": "Amount",
    "principalPortion": "Principal",
    "interestPortion": "Interest",
    "recordPayment": "Record payment",
    "recording": "Recording",
    "sourceAccount": "Paid from",
    "selectSourceAccount": "Select an account",
    "paymentErrorBody": "The payment could not be recorded. Try again.",
    "projectedInterest": "Interest accrual projection",
    "projectionHorizon": "Horizon",
    "monthsAhead": "{count} months",
    "projectionExplanation": "A projection, not a record: it assumes no further payments and the outstanding principal held exactly as it is today. The real figure will differ the moment you record a payment.",
    "noProjections": "No projection is available for this horizon.",
    "projectedOn": "Projected for {date}",
    "projectionChartLabel": "Projected interest from {from} to {to}, reaching {toValue}",
    "repaid": "Repaid",
    "notYetDrawn": "Not yet drawn",
    "recordDrawdown": "Record money received",
    "drawdownAmount": "Amount received",
    "drawdownAccount": "Received into",
    "drawdownExplanation": "Posts the principal to the account you choose, dated on the date the loan was received.",
    "drawdownErrorBody": "The loan payout could not be recorded. Try again.",
    "repaidOf": "{repaid} of {original}",
    "extension": {
      "hint": "Loan payment",
      "paymentLabel": "Loan payment · {name}",
      "borrowingLabel": "Borrowing · {name}",
      "interestLabel": "Loan interest · {name}",
      "borrowingBlocked": "Taler does not record extra borrowing on a loan yet.",
      "interestBlocked": "Interest on this loan is booked automatically each month; recording it here would count it twice.",
      "currencyMismatch": "Pay this loan from a {currency} account",
      "interestFirst": "Interest settled first",
      "overpayment": "Overpayment",
      "estimateNote": "Estimated from today's accrued interest; Taler computes the final split when it posts."
    },
    "overpaymentPortion": "Overpayment",
    "addLoanTitle": "Add loan",
    "subtitle": "Track your loans, repayments and interest.",
    "summary": {
      "totalOutstanding": "Total outstanding",
      "monthlyPayments": "Monthly payments",
      "estimatedInterest": "Total interest (est.)"
    },
    "remaining": "{amount} remaining",
    "termElapsed": "{percent}% of term elapsed",
    "overdue": "Overdue",
    "active": "Active",
    "notSet": "Not set",
    "endDate": "End date",
    "endDateOptional": "End date (optional)",
    "lender": "Lender",
    "lenderOptional": "Lender (optional)",
    "lenderPlaceholder": "e.g. CIB Bank",
    "rateType": "Fixed or variable",
    "rateTypeNotSet": "Not set",
    "rateFixed": "Fixed",
    "rateVariable": "Variable",
    "startDate": "Start date",
    "interestRate": "Interest rate",
    "monthlyPayment": "Monthly payment",
    "monthlyPaymentOptional": "Monthly payment (optional)",
    "loanTypeLabel": "Loan type",
    "loanType": {
      "MORTGAGE": "Mortgage",
      "CAR": "Car",
      "STUDENT": "Student",
      "PERSONAL": "Personal",
      "OTHER": "Other"
    },
    "loanDetails": "Loan details",
    "initialAmountSuffix": "initial amount",
    "viewAll": "View all",
    "createLoan": "Create loan",
    "editTerms": "Edit terms",
    "editTermsTitle": "Edit loan terms",
    "termsErrorBody": "The terms could not be saved. Try again.",
    "deleteTitle": "Delete loan",
    "deleteConsequence": "This permanently deletes the loan and its empty accounts. Loans with payments or accrued interest cannot be deleted.",
    "deleteAction": "Delete loan",
    "deleting": "Deleting…",
    "deleteErrorBody": "The loan could not be deleted. Try again.",
    "actionsLabel": "Actions for {name}",
    "tabs": {
      "overview": "Overview",
      "payments": "Payments",
      "interest": "Interest",
      "details": "Details"
    }
  },
  "relationships": {
    "connectCta": "Connect a ledger",
    "close": "Close",
    "title": "Relationships",
    "intro": "Connect ledgers so they can send each other money.",
    "noLedger": "No ledger is available for your account yet.",
    "noAccess": "You do not have permission to manage this ledger's relationships.",
    "receivedTitle": "Waiting for you",
    "receivedEmpty": "Nothing is waiting for your answer.",
    "proposalFrom": "{ledger} wants to connect with this ledger",
    "connectionRequest": "Connection request",
    "acceptConsequence": "Accepting connects the two ledgers right away. This cannot be undone from here.",
    "accept": "Accept",
    "decline": "Decline",
    "establishedTitle": "Connected ledgers",
    "establishedEmpty": "No connected ledgers yet. Connect one to start sending money.",
    "sentTitle": "Sent by you",
    "sentEmpty": "You have not asked any ledger to connect yet.",
    "proposalTo": "To {ledger}",
    "requestedOn": "Requested on {date}",
    "statusProposed": "Waiting",
    "statusAccepted": "Accepted",
    "statusDeclined": "Declined",
    "settlement": "How will money move?",
    "settlementContribution": "Contribution",
    "settlementContributionHint": "A one-way transfer of money, not paid back later.",
    "settlementReimbursementHint": "Pays back a cost the other ledger covered for you.",
    "settlementReimbursement": "Reimbursement",
    "disclosure": "{ledger} will see this proposal, including that it comes from {source} and the option you chose. They can accept or decline it; nothing is connected until they accept.",
    "propose": "Send proposal",
    "proposeFailed": "The proposal could not be sent. Try again.",
    "proposeToSelf": "This is your own ledger's code. A proposal needs another ledger.",
    "ownCodeTitle": "Your ledger code",
    "ownCodeHint": "Share this code so another ledger's owner can connect with this ledger. They see only this ledger's name.",
    "ownCodeValue": "Ledger code {code}",
    "copyCode": "Copy code",
    "copied": "Copied",
    "rotateCode": "Get a new code",
    "rotateConsequence": "The current code stops working straight away. Ledgers already connected stay connected.",
    "rotateConfirm": "Get a new code",
    "rotateKeep": "Keep this code",
    "rotateFailed": "The code could not be changed. Try again.",
    "connectTitle": "Connect a ledger",
    "connectIntro": "Enter the five-character code the other ledger's owner shared with you.",
    "codeLabel": "Ledger code",
    "codeHint": "Five letters or digits. Case does not matter. 0, 1, I and O are not used.",
    "codeInvalid": "Enter five letters or digits. 0, 1, I and O are not used in codes.",
    "findLedger": "Find ledger",
    "codeNotFound": "No ledger has this code. Check it with the other ledger's owner.",
    "codeRateLimited": "Too many codes were checked recently. Wait up to an hour, then try again.",
    "codeLookupFailed": "The ledger could not be found. Try again.",
    "previewTitle": "Ledger found",
    "previewLine": "Connect with {ledger}?",
    "unknownLedger": "Another ledger",
    "loadFailed": "Connected ledgers could not be loaded.",
    "retry": "Try again"
  },
  "reporting": {
    "title": "Reports",
    "netWorthTitle": "Net worth",
    "periodRollupTitle": "By period",
    "periodRollupPeriodColumn": "Period",
    "rollupTitle": "Parent rollup",
    "noLedger": "No ledger is available for your account yet.",
    "noAccess": "You do not have permission to view this ledger's reports.",
    "loading": "Loading report",
    "errorTitle": "Report could not be loaded",
    "retry": "Try again",
    "displayCurrency": "Currency",
    "accountClass": "Class",
    "classExpense": "Expense",
    "classIncome": "Income",
    "bucket": "Bucket",
    "bucketDay": "Day",
    "bucketWeek": "Week",
    "bucketMonth": "Month",
    "bucketYear": "Year",
    "date": "Date",
    "from": "From",
    "until": "Until",
    "stepEarlier": "Previous month",
    "stepLater": "Next month",
    "netWorthAsOf": "Net worth as of {date}",
    "bucketColumnWeek": "W{week} {year}",
    "pivotAmountsIn": "Amounts are shown in {currency}.",
    "pivotTotalRow": "Total",
    "periodRollupIncludesChildren": "incl. subcategories",
    "pivotEmpty": "No postings in this range.",
    "rollupAccountColumn": "Account",
    "rollupOwnColumn": "Own balance",
    "rollupRolledUpColumn": "Rolled up",
    "rollupOtherRow": "Egyéb (Other)",
    "rollupEmpty": "No accounts in this class.",
    "netWorthChart": {
      "title": "Net worth over time",
      "summary": "Net worth from {from} ({fromValue}) to {to} ({toValue})",
      "resolutionDaily": "One point per day",
      "resolution": "One point every {days} days",
      "showTable": "Show as table",
      "tableCaption": "Net worth by date",
      "tableDate": "Date",
      "tableValue": "Net worth",
      "emptyTitle": "No net worth yet",
      "emptyBody": "Net worth appears once this ledger has postings.",
      "noMatchTitle": "No postings in this range",
      "noMatchBody": "Choose an earlier From date, or clear it to see the full history.",
      "invalidRange": "From must be on or before the date."
    },
    "overview": {
      "subtitle": "Understand your finances with detailed insights.",
      "headlines": "Headline figures"
    },
    "tabs": {
      "overview": "Overview",
      "incomeExpenses": "Income & expenses",
      "accounts": "Accounts",
      "categories": "Categories",
      "payees": "Payees",
      "tags": "Tags",
      "trends": "Trends",
      "childSummary": "Child summary",
      "lentTo": "Lent to"
    },
    "lentTo": {
      "subtitle": "Contacts and other ledgers you have lent money to.",
      "title": "Lent to",
      "name": "Name",
      "owed": "Owed",
      "repaid": "Repaid",
      "forgiven": "Forgiven",
      "actions": "Actions",
      "forgive": "Forgive",
      "empty": {
        "title": "Nothing lent out",
        "body": "Once a receivable or a cross-ledger loan exists, it appears here."
      },
      "noTransferHere": "You do not have posting rights in this ledger.",
      "noTransferThere": "You do not have posting rights in the other ledger."
    },
    "rangeEarlier": "Earlier period",
    "rangeLater": "Later period",
    "bucketDaily": "Daily",
    "bucketWeekly": "Weekly",
    "bucketMonthly": "Monthly",
    "bucketYearly": "Yearly",
    "invertedRange": "From must be on or before until.",
    "rangeTooLong": "This window is too long to show at any interval. Narrow the dates.",
    "kpi": {
      "income": "Total income",
      "expenses": "Total expenses",
      "net": "Net result",
      "savings": "Savings rate",
      "vsPrevious": "vs. previous period"
    },
    "chart": {
      "incomeVsExpenses": "Income vs. expenses",
      "income": "Income",
      "expenses": "Expenses",
      "net": "Net",
      "flowsAria": "Income and expenses per period",
      "netAria": "Net per period",
      "empty": "No periods in this range."
    },
    "expensesByCategory": "Expenses by category",
    "other": "Other",
    "total": "Total",
    "viewAll": "View all",
    "topPayees": "Top payees",
    "topCategories": "Top categories",
    "topTags": "Top tags",
    "noPayee": "No payee",
    "untagged": "Untagged",
    "unknownAccount": "Unknown account",
    "severalCategories": "Several categories",
    "severalAccounts": "Several accounts",
    "largest": {
      "title": "Recent large transactions",
      "date": "Date",
      "payee": "Payee / description",
      "category": "Category",
      "account": "Account",
      "amount": "Amount",
      "tags": "Tags",
      "empty": "No money moved in this range.",
      "actions": "Actions"
    },
    "table": {
      "name": "Name",
      "entries": "Entries",
      "amount": "Amount",
      "share": "Share",
      "period": "Period"
    },
    "empty": {
      "title": "Nothing to show in this range",
      "body": "Choose a wider range or another interval."
    },
    "accounts": {
      "account": "Account",
      "inflow": "In",
      "outflow": "Out",
      "transfersIn": "Transfers in",
      "transfersOut": "Transfers out",
      "net": "Net",
      "noAccess": "Account balances need a permission this role does not have."
    },
    "tags": {
      "note": "An entry counts under every one of its tags, so tag totals can add up to more than the total."
    },
    "trends": {
      "savingsRate": "Savings rate for this range: {rate}",
      "netTitle": "Net per period"
    },
    "interval": "Interval",
    "periodCount": "{count} period | {count} periods",
    "categoryCount": "{count} category | {count} categories",
    "periodRollupTotalSuffix": "total"
  },
  "planning": {
    "title": "Planning",
    "subtitle": "Set goals and plan your financial future."
  },
  "targets": {
    "title": "Targets",
    "loading": "Loading targets",
    "emptyTitle": "No targets yet",
    "emptyBody": "Add a target to track progress toward a goal.",
    "errorTitle": "Targets could not be loaded",
    "errorBody": "Something went wrong while loading your targets.",
    "retry": "Try again",
    "noLedger": "No ledger is available for your account yet.",
    "noAccess": "You do not have permission to manage this ledger's targets.",
    "targetLine": "Target",
    "addTarget": "Add target",
    "actionsLabel": "Actions for {name}",
    "nameLabel": "Name",
    "metricLabel": "What to track",
    "currencyLabel": "Target currency",
    "selectCurrency": "Choose a currency",
    "accountLabel": "Account",
    "noAccount": "No account chosen",
    "minValueLabel": "Minimum",
    "maxValueLabel": "Maximum",
    "minValuePercentLabel": "Minimum (%)",
    "maxValuePercentLabel": "Maximum (%)",
    "goalDateLabel": "Goal date",
    "chooseCurrencyFirst": "Choose a currency first",
    "currencyRequired": "Choose a currency for this metric",
    "invalidBound": "Enter a valid number",
    "createErrorBody": "The target could not be created.",
    "save": "Create",
    "saving": "Saving…",
    "cancel": "Cancel",
    "deleteAction": "Delete",
    "deleting": "Deleting…",
    "metric": {
      "ACCOUNT_BALANCE": "Account balance",
      "NET_WORTH": "Net worth",
      "MONTHLY_SAVINGS": "Monthly savings",
      "EXPENSE_INCOME_RATIO": "Expense/income ratio",
      "LIABILITY_ASSET_RATIO": "Debt/asset ratio"
    },
    "status": {
      "MET": "On track",
      "NOT_MET_IN_PROGRESS": "In progress",
      "NOT_MET_MISSED": "Missed",
      "NO_DATA": "No data yet",
      "NO_ACCOUNT": "No account chosen"
    },
    "targetDate": "Target date",
    "accountOnLine": "Account"
  },
  "prepaidRecognitions": {
    "sectionLabel": "Prepaid recognition schedule",
    "title": "Recognise over time",
    "loading": "Loading recognition schedule",
    "errorTitle": "This schedule could not be loaded",
    "retry": "Try again",
    "totalAmount": "Total",
    "recognizedAmount": "Recognised",
    "pendingAmount": "Pending",
    "cancelledAmount": "Cancelled",
    "status": {
      "PENDING": "Pending",
      "RECOGNIZED": "Recognised",
      "CANCELLED": "Cancelled"
    },
    "viewEntry": "View entry",
    "explanation": "Spread this payment across several periods instead of counting it as one expense in the month you paid. Each period recognises its own slice on its own date.",
    "expenseAccountLabel": "Recognise into",
    "selectExpenseAccount": "Select an account",
    "spreadLabel": "Spread across periods",
    "singlePaymentHint": "Recognised as a single payment on the date below.",
    "periodsLabel": "Number of periods",
    "startDateLabel": "First recognition date",
    "consequence": "This schedules a real posting for every period: each recognition date moves its slice from this payment into the account above. Nothing posts until its own date arrives.",
    "pendingRetry": "Still processing the previous attempt - try again in a moment.",
    "scheduleAction": "Schedule recognition",
    "scheduling": "Scheduling",
    "extension": {
      "label": "Prepaid expense",
      "chooseExpense": "Choose the account it is recognised into",
      "invalidPeriods": "Enter a whole number of periods"
    }
  },
  "garage": {
    "title": "Garage",
    "subtitle": "Cars and vehicle events",
    "addCar": "Add car",
    "loading": "Loading cars",
    "emptyTitle": "No cars",
    "emptyBody": "Add your first car",
    "errorTitle": "Cars could not be loaded",
    "detailErrorTitle": "This car could not be loaded",
    "errorBody": "Something went wrong while reading the car. Try again.",
    "retry": "Try again",
    "noLedger": "No ledger is available for your account yet.",
    "noAccess": "You do not have permission to view this ledger's garage.",
    "primary": "Primary",
    "selector": {
      "label": "Cars"
    },
    "moreActions": "More actions",
    "tabsLabel": "Car sections",
    "setPrimary": "Mark as primary car",
    "setPrimaryError": "The primary car could not be changed. Try again.",
    "status": {
      "ACTIVE": "Active",
      "SOLD": "Sold"
    },
    "form": {
      "nameLabel": "Name",
      "namePlaceholder": "e.g. The grey one",
      "make": "Make",
      "makePlaceholder": "e.g. Toyota",
      "model": "Model",
      "modelPlaceholder": "e.g. Corolla",
      "year": "Year",
      "yearPlaceholder": "e.g. 2020",
      "color": "Colour",
      "colorPlaceholder": "e.g. Grey",
      "licensePlate": "Licence plate",
      "licensePlatePlaceholder": "e.g. ABC-123",
      "vin": "VIN / chassis number",
      "vinPlaceholder": "17-character VIN",
      "fuelTypeLabel": "Fuel type",
      "selectFuelType": "Select...",
      "initialMileage": "Initial odometer",
      "initialMileagePlaceholder": "0",
      "purchaseDate": "Purchase date",
      "notes": "Notes",
      "notesPlaceholder": "Other notes...",
      "makePrimary": "Make this the primary car",
      "cancel": "Cancel",
      "create": "Create",
      "save": "Save",
      "saving": "Saving",
      "invalidAmount": "Enter a valid number",
      "createErrorBody": "Something went wrong while creating the car. Try again.",
      "updateErrorBody": "Something went wrong while saving the car. Try again."
    },
    "fuelType": {
      "DIESEL": "Diesel",
      "PETROL": "Petrol",
      "ELECTRIC": "Electric",
      "HYBRID": "Hybrid",
      "GAS": "Gas"
    },
    "edit": "Edit",
    "delete": "Delete",
    "deleteCarTitle": "Delete {name}?",
    "deleteCarBody": "This action is irreversible. All events, policies and schedules belonging to {name} will also be deleted.",
    "deleteCarConfirm": "Delete",
    "deleteCarError": "The car could not be deleted. Try again.",
    "cancel": "Cancel",
    "stats": {
      "title": "Statistics",
      "currentMileage": "Current odometer",
      "totalSpend": "Total spend",
      "spendInYear": "Spend in {year}",
      "costPerKm": "Cost per km",
      "costPerKmUnknown": "No distance this period",
      "odometerConflict": "Odometer readings conflict",
      "breakdownTitle": "Breakdown by account",
      "noStatistics": "No statistics yet",
      "eventCounts": "Event counts",
      "periodLabel": "Statistics period",
      "previousPeriod": "Previous year",
      "nextPeriod": "Next year",
      "vsLastYear": "vs last year"
    },
    "details": {
      "title": "Details",
      "licensePlate": "Licence plate",
      "vin": "VIN / chassis number",
      "fuelType": "Fuel type",
      "color": "Colour",
      "purchaseDate": "Purchase date",
      "initialMileage": "Initial odometer",
      "notes": "Notes"
    },
    "events": {
      "title": "Events",
      "empty": "No events",
      "logEvent": "Log event",
      "sellCar": "Sell car",
      "alreadySold": "This car has already been sold.",
      "cannotAddToSold": "Cannot add events to a sold car. Only the sell event is allowed.",
      "typeTitle": "Event type",
      "linkedEntry": "Journal entry",
      "edit": "Edit",
      "delete": "Delete",
      "deleteTitle": "Delete event",
      "deleteBody": "Are you sure you want to delete this event?",
      "recordErrorBody": "Something went wrong while recording the event. Try again.",
      "recentTitle": "Recent events",
      "columns": {
        "date": "Date",
        "type": "Type",
        "description": "Description",
        "odometer": "Odometer",
        "amount": "Amount",
        "account": "Account",
        "notes": "Notes"
      }
    },
    "eventType": {
      "FUEL": "Refuelling",
      "REPAIR": "Service / repair",
      "INSURANCE_PAYMENT": "Insurance premium",
      "TAX": "Tax / duty",
      "INSPECTION": "Roadworthiness test",
      "REGISTRATION": "Registration document",
      "CAR_WASH": "Car wash",
      "PARKING": "Parking",
      "FINE": "Fine",
      "MILEAGE_LOG": "Odometer log",
      "SELL": "Sale",
      "BUY": "Purchase (car)",
      "TIRE_CHANGE": "Tyre change"
    },
    "eventField": {
      "date": "Date",
      "mileage": "Odometer",
      "notes": "Notes",
      "fuelAmount": "Fuel amount (litres)",
      "fuelStation": "Station",
      "fuelTypeOverride": "Fuel type override",
      "fuelTypeDefault": "Uses the car's fuel type ({fuelType})",
      "fuelTypeOverrideToggle": "Override",
      "fuelTypeUseDefault": "Use the car's fuel type",
      "selectDefault": "Default",
      "repairShop": "Repair shop",
      "description": "Description",
      "items": "Work done",
      "itemsHint": "Comma separated",
      "fulfilledScheduleIds": "Schedules fulfilled",
      "policyId": "Policy",
      "selectPolicy": "Select a policy...",
      "installmentNumber": "Instalment number",
      "taxType": "Tax type",
      "taxPeriod": "Tax period",
      "authority": "Authority",
      "referenceNumber": "Reference number",
      "station": "Inspection station",
      "result": "Result",
      "validUntil": "Valid until",
      "expiryDate": "Expiry date",
      "washType": "Wash type",
      "location": "Location",
      "durationMinutes": "Duration (minutes)",
      "fineType": "Fine type",
      "status": "Status",
      "dueDate": "Due date",
      "buyerNotes": "Notes about the buyer",
      "sellerNotes": "Notes about the seller",
      "axle": "Axle",
      "tireType": "Tyre type",
      "brand": "Brand",
      "shop": "Shop"
    },
    "inspectionResult": {
      "PASS": "Pass",
      "FAIL": "Fail",
      "CONDITIONAL": "Conditional"
    },
    "washType": {
      "SELF_SERVICE": "Self-service",
      "AUTOMATIC": "Automatic",
      "HAND_WASH": "Hand wash",
      "DETAILING": "Detailing"
    },
    "fineType": {
      "SPEEDING": "Speeding",
      "PARKING": "Parking fine",
      "OTHER": "Other"
    },
    "fineStatus": {
      "UNPAID": "Unpaid",
      "PAID": "Paid",
      "CONTESTED": "Contested"
    },
    "taxType": {
      "WEIGHT_TAX": "Weight tax",
      "ROAD_TOLL": "Road toll",
      "OTHER": "Other"
    },
    "tireType": {
      "SUMMER": "Summer",
      "WINTER": "Winter",
      "ALL_SEASON": "All-season"
    },
    "axle": {
      "FRONT": "Front axle",
      "REAR": "Rear axle",
      "ALL": "All four wheels"
    },
    "journal": {
      "title": "Journal entry",
      "none": "No journal entry",
      "unchanged": "Keep as is",
      "create": "Create a new entry",
      "link": "Link an existing entry",
      "expenseAccount": "Expense account",
      "selectExpenseAccount": "Select an account",
      "incomeAccount": "Income account",
      "selectIncomeAccount": "Select an account",
      "sourceAccount": "Source account",
      "selectSourceAccount": "Select an account",
      "amount": "Amount",
      "payee": "Payee",
      "payeePlaceholder": "e.g. MOL",
      "entryLabel": "Journal entry",
      "selectEntry": "Select an entry...",
      "noEntryFound": "No journal entry found",
      "fineRequiresJournal": "This fine has a cost. Please link or create a journal entry when marking it as paid."
    },
    "policies": {
      "title": "Insurance policies",
      "add": "Add policy",
      "empty": "No policies",
      "insurer": "Insurer",
      "insurerPlaceholder": "e.g. Generali",
      "policyNumber": "Policy number",
      "policyNumberPlaceholder": "e.g. GEN-12345678",
      "type": "Type",
      "selectType": "Select...",
      "coverageStart": "Coverage start",
      "coverageEnd": "Coverage end",
      "paymentSchedule": "Payment schedule",
      "selectPaymentSchedule": "Select...",
      "notes": "Notes",
      "notesPlaceholder": "Other notes...",
      "cancel": "Cancel",
      "create": "Create",
      "delete": "Delete",
      "createErrorBody": "Something went wrong while creating the policy. Try again."
    },
    "policyType": {
      "THIRD_PARTY": "Third-party liability",
      "CASCO": "Casco",
      "COMPREHENSIVE": "Comprehensive",
      "OTHER": "Other"
    },
    "paymentSchedule": {
      "ANNUAL": "Annual",
      "SEMI_ANNUAL": "Semi-annual",
      "QUARTERLY": "Quarterly",
      "MONTHLY": "Monthly"
    },
    "schedules": {
      "title": "Maintenance schedules",
      "add": "Add schedule",
      "empty": "No schedules",
      "nameLabel": "Name",
      "namePlaceholder": "e.g. Oil change",
      "intervalCaption": "Interval",
      "intervalHint": "At least one interval must be given",
      "intervalKm": "Kilometre interval",
      "intervalKmPlaceholder": "e.g. 10000",
      "intervalMonths": "Month interval",
      "intervalMonthsPlaceholder": "e.g. 12",
      "intervalRequired": "Interval required",
      "lastDone": "Last",
      "never": "Never",
      "cancel": "Cancel",
      "create": "Create",
      "delete": "Delete",
      "markDone": "Mark as done",
      "markDoneTitle": "Mark as done",
      "markDoneBody": "Enter the completion details",
      "doneDate": "Completion date",
      "doneMileage": "Odometer",
      "doneMileagePlaceholder": "e.g. 85000",
      "createErrorBody": "Something went wrong while creating the schedule. Try again.",
      "markDoneErrorBody": "Something went wrong while marking the schedule done. Try again."
    },
    "tabOverview": "Overview",
    "extension": {
      "label": "Car event",
      "noCar": "Add the car in Garage first.",
      "loadingCars": "Loading cars…",
      "chooseCar": "Choose the car",
      "chooseType": "Choose the event type",
      "car": "Car",
      "type": "Event type",
      "finePaid": "Recorded as paid, since this entry is the payment.",
      "ownRow": "Put the car cost in its own row - a car event cannot share an entry with other expenses yet."
    },
    "categories": {
      "maintenance": "Maintenance",
      "refuelling": "Refuelling",
      "parking": "Parking",
      "carWash": "Car wash",
      "insurance": "Insurance",
      "other": "Other"
    },
    "photo": {
      "title": "Photo",
      "acceptHint": "JPEG, PNG or WebP, up to 5 MB",
      "browse": "Choose photo",
      "dropHint": "or drop a photo here",
      "removeFile": "Remove chosen photo",
      "invalidFileType": "Only JPEG, PNG or WebP photos can be chosen.",
      "upload": "Upload photo",
      "uploading": "Uploading…",
      "remove": "Remove photo",
      "removing": "Removing…",
      "removeError": "The photo could not be removed.",
      "errors": {
        "size": "The photo must be between 1 byte and 5 MB.",
        "type": "Only JPEG, PNG or WebP photos can be stored.",
        "generic": "The photo could not be saved. Try again."
      },
      "replace": "Replace photo"
    }
  },
  "receiptScan": {
    "title": "Receipt scan",
    "description": "Upload a photo of a receipt to read it into a journal entry.",
    "noLedger": "No ledger is available for your account yet.",
    "noAccess": "You do not have permission to scan receipts for this ledger.",
    "receiptImage": "Receipt photo",
    "browseFile": "Choose a photo",
    "dropHint": "or drag and drop",
    "acceptHint": "JPEG, PNG, WebP or GIF",
    "removeFile": "Remove photo",
    "invalidFileType": "That file isn't a supported image. Choose a JPEG, PNG, WebP or GIF photo instead.",
    "paymentSource": "Payment source",
    "scanReceipt": "Scan receipt",
    "uploading": "Uploading…",
    "previewAlt": "The uploaded receipt photo",
    "loading": "Loading receipt scans",
    "errorTitle": "Receipt scans could not be loaded",
    "scanErrorTitle": "This receipt scan could not be loaded",
    "errorBody": "Something went wrong while reading your receipt scans. Try again.",
    "retry": "Try again",
    "emptyTitle": "No receipts scanned yet",
    "emptyBody": "Upload a photo of a receipt to turn it into a journal entry.",
    "tableRegion": "Receipt scans",
    "uploaded": "Uploaded",
    "payee": "Payee",
    "total": "Total",
    "actions": "Actions",
    "unknownMerchant": "Unknown merchant",
    "continue": "Continue",
    "view": "View",
    "status": {
      "label": "Status",
      "MANUAL": "Enter manually",
      "PENDING": "Analysing…",
      "READY": "Ready to review",
      "NEEDS_REVIEW": "Needs review",
      "FAILED": "Failed",
      "COMMITTED": "Committed"
    },
    "analysing": "Reading the receipt…",
    "date": "Date",
    "statedTotal": "Stated total",
    "lineCategory": "Category",
    "boughtBy": "Bought by",
    "boughtByYou": "You",
    "owedByContact": "They owe you this",
    "itemName": "Item",
    "amount": "Amount",
    "quantity": "Quantity",
    "rowActions": "Row actions",
    "removeItem": "Remove item",
    "addItem": "Add item",
    "payeePlaceholder": "e.g. Lidl",
    "mismatchWarning": "The items do not add up to the stated total yet. Fix the amounts below before committing.",
    "confirmCreate": "Create entry",
    "committing": "Creating…",
    "startOver": "Back to receipt scans",
    "needsReviewNotice": "The automatic reading could not be reconciled with the stated total after a few attempts. Check the items below, or try scanning again.",
    "rescan": "Scan again",
    "rescanning": "Scanning again…",
    "committedNotice": "This receipt has been committed to the journal.",
    "cannotDelete": "A successfully scanned receipt can never be deleted.",
    "enterManually": "This scan failed, so it can be deleted from the receipt scan list, or you can enter the details below yourself and commit when ready.",
    "viewEntryAndReverse": "View the entry to reverse it instead.",
    "delete": "Delete",
    "deleteConfirmAction": "Yes, delete",
    "deleteCancel": "Cancel",
    "failure": {
      "AI_UNAVAILABLE": "Automatic receipt reading is unavailable right now. Try scanning again, or enter the details yourself below.",
      "EXTRACTION_FAILED": "The receipt could not be read automatically. Try scanning again, or enter the details yourself below.",
      "UNKNOWN": "This scan failed. Try scanning again, or enter the details yourself below."
    }
  },
  "imports": {
    "title": "CSV import",
    "description": "Upload a bank statement, map its columns, review what will be created and commit.",
    "noLedger": "No ledger is available for your account yet.",
    "noAccess": "You do not have permission to import transactions for this ledger.",
    "backToJobs": "Back to imports",
    "upload": {
      "file": "CSV file",
      "browseFile": "Choose a file",
      "dropHint": "or drag and drop",
      "acceptHint": "CSV files",
      "removeFile": "Remove file",
      "invalidFileType": "That file isn't a CSV. Choose a .csv file instead.",
      "statementAccount": "Statement account",
      "selectStatementAccount": "Select an account",
      "createJob": "Upload and preview",
      "creating": "Uploading…"
    },
    "mapping": {
      "title": "Column mapping",
      "description": "Say which column in your file holds each piece of information. A wrong guess can be corrected here, without starting over.",
      "none": "(none)",
      "placeholders": {
        "selectColumn": "Select a column…"
      },
      "fields": {
        "date": "Date",
        "amount": "Amount",
        "description": "Description",
        "accountCode": "Account code",
        "externalReference": "External reference"
      }
    },
    "status": {
      "OPEN": "Open",
      "COMMITTED": "Committed",
      "ABANDONED": "Abandoned"
    },
    "list": {
      "loading": "Loading imports",
      "errorTitle": "Imports could not be loaded",
      "errorBody": "Something went wrong while reading imports. Try again.",
      "retry": "Try again",
      "emptyTitle": "No imports yet",
      "emptyBody": "Upload a CSV file to bring transactions into this ledger.",
      "tableRegion": "Import jobs",
      "uploaded": "Uploaded",
      "file": "File",
      "statusLabel": "Status",
      "actions": "Actions",
      "continue": "Continue",
      "view": "View"
    },
    "detail": {
      "loading": "Loading the import",
      "errorTitle": "The import could not be loaded",
      "errorBody": "Something went wrong while reading this import. Try again.",
      "abandon": "Abandon",
      "committedNotice": "This import has been committed to the journal.",
      "commit": "Commit import",
      "committing": "Committing…"
    },
    "preview": {
      "notice": "This is a preview. Nothing is created until you commit.",
      "totalRows": "Total rows",
      "invalidRows": "Invalid rows",
      "duplicateRows": "Possible duplicates",
      "toCommit": "To be created",
      "rowNumber": "Row {number}",
      "date": "Date",
      "description": "Description",
      "amount": "Amount",
      "counterAccount": "Counter account",
      "excluded": "Excluded",
      "selectAccount": "Select an account",
      "searchAccounts": "Search accounts",
      "noAccountsFound": "No accounts found",
      "duplicate": "Possible duplicate",
      "viewMatch": "View match"
    }
  },
  "forecast": {
    "title": "Forecast",
    "loading": "Loading forecast",
    "emptyTitle": "No scenarios yet",
    "emptyBody": "Create a scenario to project where your net worth is headed.",
    "errorTitle": "Scenarios could not be loaded",
    "errorBody": "Something went wrong while loading your forecast.",
    "detailErrorTitle": "Scenario could not be loaded",
    "projectionErrorTitle": "The projection could not be loaded",
    "retry": "Try again",
    "noLedger": "No ledger is available for your account yet.",
    "noAccess": "You do not have permission to manage this ledger's forecast.",
    "addScenario": "Add scenario",
    "nameLabel": "Name",
    "createErrorBody": "The scenario could not be created.",
    "save": "Create",
    "saving": "Saving…",
    "cancel": "Cancel",
    "deleteAction": "Delete",
    "actionsLabel": "Actions for {name}",
    "deleting": "Deleting…",
    "projectionTitle": "Projection",
    "horizonLabel": "Horizon",
    "monthsAhead": "{count} months",
    "horizonCaption": "{count} month forecast",
    "displayCurrency": "Display currency",
    "flatProjectionNote": "This scenario has no variables or events yet, so the projection is a straight line at today's net worth.",
    "projectionChartLabel": "Net worth from {fromValue} on {from} to {toValue} on {to}",
    "checkAgainstTarget": "Check against a target",
    "chooseTarget": "Choose a target",
    "targetReachedBy": "On track to meet this target by {date}",
    "targetNotReached": "Not on track to meet this target within this horizon",
    "variablesTitle": "Variables",
    "addVariable": "Add variable",
    "noVariables": "No variables yet.",
    "monthlyAmountLabel": "Monthly amount",
    "amountLabel": "Amount",
    "amountPlaceholder": "e.g. -800 or 500",
    "currencyLabel": "Currency",
    "selectCurrency": "Choose a currency",
    "currencyRequired": "Choose a currency",
    "invalidAmount": "Enter a valid amount",
    "startDateLabel": "Starts",
    "endDateLabel": "Ends",
    "endDateHint": "Leave the end date empty to keep this variable running through the projection horizon.",
    "dateLabel": "Date",
    "variableErrorBody": "The variable could not be added.",
    "variablePeriodOpen": "From {start}, ongoing",
    "variablePeriodClosed": "{start} – {end}",
    "eventsTitle": "Events",
    "addEvent": "Add event",
    "noEvents": "No events yet.",
    "eventErrorBody": "The event could not be added."
  },
  "identityAdmin": {
    "title": "Account administration",
    "noAccess": "You do not have permission to manage sessions or suspend accounts.",
    "subjectLabel": "Account (subject)",
    "subjectPlaceholder": "Exact subject, case-sensitive",
    "lookUp": "Look up",
    "subjectHelp": "Sessions and suspension act on the exact subject you enter - there is no directory to search.",
    "ownAccountNote": "This is your own account.",
    "sessionsTitle": "Active sessions",
    "sessionsEmpty": "No active sessions.",
    "sessionsLoading": "Loading sessions",
    "sessionsErrorTitle": "Sessions could not be loaded",
    "sessionsErrorBody": "Something went wrong while reading sessions. Try again.",
    "retry": "Try again",
    "endSession": "End session",
    "endingSession": "Ending…",
    "endSessionNote": "Ending a session takes effect immediately, on that session's very next request. Ending your own current session signs you out.",
    "endSessionError": "Could not end this session. Try again.",
    "device": "Device",
    "unknownDevice": "Unknown device",
    "createdAt": "Started",
    "expiresAt": "Expires",
    "statusTitle": "Account status",
    "statusUnknown": "Unknown until you suspend or restore this account.",
    "statusActive": "Active",
    "statusSuspended": "Suspended",
    "suspendAction": "Suspend account",
    "suspendConfirmTitle": "Suspend {subject}?",
    "suspendConfirmBody": "They will be unable to sign in, and every active session ends immediately. Restore the account any time to reverse this.",
    "suspendConfirmAction": "Suspend account",
    "suspendCancel": "Cancel",
    "suspendError": "Could not suspend this account. Try again.",
    "suspending": "Suspending…",
    "restoreAction": "Restore account",
    "restoreError": "Could not restore this account. Try again.",
    "restoring": "Restoring…",
    "cannotSuspendSelf": "You cannot suspend your own account."
  },
  "reconciliation": {
    "list": {
      "title": "Reconciliations",
      "start": "New reconciliation",
      "resume": "Resume reconciliation",
      "noLedger": "No ledger is available for your account yet.",
      "noAccess": "You do not have permission to view this ledger's reconciliations.",
      "loading": "Loading reconciliations…",
      "errorTitle": "Reconciliations could not be loaded",
      "errorBody": "Something went wrong while reading reconciliations. Try again.",
      "retry": "Try again",
      "emptyTitle": "No reconciliations yet",
      "emptyBody": "Start a reconciliation to check your account balances against reality.",
      "loadMore": "Load more"
    },
    "history": {
      "date": "Date",
      "status": "Status",
      "checked": "Checked",
      "corrected": "Corrected",
      "transfers": "Transfers",
      "finished": "Finished",
      "open": "Open",
      "view": "View"
    },
    "editor": {
      "title": "Reconciliation",
      "dateLabel": "Actual balances as of",
      "progress": "{entered} of {total} accounts checked",
      "saving": "Saving…",
      "saved": "Saved",
      "errorTitle": "This reconciliation could not be loaded",
      "assets": "Assets",
      "liabilities": "Liabilities (amount owed)",
      "hiddenAccounts": "Hidden accounts ({count})",
      "actualBalanceFor": "Actual balance, {name}",
      "matches": "matches",
      "notChecked": "not checked",
      "confirm": "Confirm",
      "correction": "Correction",
      "gainLoss": "Gain/loss",
      "balanceChanged": "This account's computed balance changed - check it before finishing.",
      "proposalTitle": "What finishing will post",
      "transferHint": "transfer: money moved but was never recorded",
      "applyReallocations": "Record matched pairs as transfers",
      "nothingToPost": "Nothing will be posted for a matched pair or a correction.",
      "summaryLine": "{matched} account(s) match · {notChecked} not checked (no record will be kept for them)",
      "discard": "Discard",
      "discardConfirm": "Discard {count} entered balance(s)?",
      "discardConfirmAction": "Discard reconciliation",
      "cancel": "Cancel",
      "finish": "Finish reconciliation",
      "finishing": "Finishing…",
      "retryFinish": "One or more balances changed - review the table above and press Finish again."
    },
    "detail": {
      "account": "Account",
      "computedThen": "Computed then",
      "actual": "Actual",
      "outcome": "Outcome",
      "finishedBy": "Finished by {who}, {when}",
      "outcomeMatched": "matched",
      "outcomeCorrected": "corrected",
      "outcomeTransferred": "transferred with {name}",
      "outcomeReversed": "reversed",
      "viewEntry": "View entry"
    }
  },
  "notifications": {
    "title": "Notifications",
    "badgeLabel": "{count} unread notifications",
    "emptyTitle": "No notifications yet",
    "emptyBody": "You will see account and export notices here as they happen.",
    "errorBody": "Something went wrong while reading your notifications. Try again.",
    "errorTitle": "Notifications could not be loaded",
    "retry": "Try again",
    "markRead": "Mark as read",
    "loadMore": "Load more",
    "loadingMore": "Loading…"
  },
  "notificationPreferences": {
    "title": "Notification preferences",
    "subtitle": "Choose which notifications reach you, and on which channel.",
    "typeColumn": "Notification",
    "channel": {
      "IN_APP": "In-app",
      "EMAIL": "Email"
    },
    "mandatory": "Always on",
    "customized": "Customized",
    "showAmounts": "Show amounts in {channel}",
    "toggleLabel": "{type} by {channel}",
    "errorLoading": "Something went wrong while reading your notification preferences.",
    "errorTitle": "Notification preferences could not be loaded",
    "errorGeneric": "Something went wrong while saving your notification preferences. Try again.",
    "errorTypeMandatory": "This notification cannot be turned off.",
    "errorChannelNotSupported": "This notification is not available on that channel.",
    "type": {
      "ACCOUNT_SUSPENDED": "Your account is suspended",
      "ACCOUNT_RESTORED": "Your account is restored",
      "EXPORT_READY": "Export ready",
      "EXPORT_FAILED": "Export failed",
      "RECEIPT_SCAN_READY": "Receipt scan ready",
      "RECEIPT_SCAN_NEEDS_REVIEW": "Receipt scan needs review",
      "RECEIPT_SCAN_FAILED": "Receipt scan failed",
      "LEDGER_INVITED": "Invited to a ledger",
      "LEDGER_MEMBER_JOINED": "New member joined",
      "LEDGER_ROLE_CHANGED": "Your role changed",
      "LEDGER_MEMBER_REMOVED": "Removed from a ledger",
      "LEDGER_DISABLED": "Ledger disabled",
      "SIGN_IN_NEW_DEVICE": "Sign-in from a new device",
      "SESSION_ENDED_BY_ADMIN": "Session ended by an administrator",
      "TRANSFER_PROPOSED": "Transfer proposed",
      "TRANSFER_RESOLVED": "Transfer accepted or rejected",
      "RELATIONSHIP_PROPOSED": "Relationship proposed"
    }
  },
  "backupRestore": {
    "title": "Backup & restore",
    "noLedger": "No ledger is available for your account yet.",
    "exportTitle": "Back up this ledger",
    "exportBody": "A backup captures the whole ledger - every account, entry and posting, plus loans, contacts, targets, garage, prepaid schedules and forecasts - so it can be restored later into a fresh ledger.",
    "emptyTitle": "No backups yet",
    "emptyBody": "Request a backup to download it as a file you can restore later.",
    "restoreTitle": "Restore a backup",
    "restoreBody": "Restoring creates a brand-new, empty ledger and loads the backup file into it. An existing ledger's data is never overwritten.",
    "ledgerName": "New ledger name",
    "ledgerNamePlaceholder": "e.g. Restored household",
    "fileLabel": "Backup file",
    "fileAcceptHint": "JSON backup file",
    "fileBrowse": "Browse",
    "fileDropHint": "or drop it here",
    "fileRemove": "Remove file",
    "fileInvalidType": "That file is not a JSON backup.",
    "restore": "Restore backup",
    "restoring": "Restoring…",
    "restoreError": "The backup could not be restored. Check the file and try again.",
    "restoreSuccess": "Restored {accounts} accounts and {entries} entries into the new ledger.",
    "openRestoredLedger": "Open the restored ledger"
  },
  "ledgerLifecycle": {
    "title": "Household status",
    "noLedger": "No household is selected.",
    "statusActive": "Active",
    "statusDisabled": "Disabled",
    "activeBody": "Disabling a household locks every member out at once. Its data is kept exactly as it is, and you can restore it at any time from this page.",
    "disabledBody": "This household is disabled: nobody can read or change its data, and members cannot open it. Restoring it brings it back exactly as it was.",
    "disableAction": "Disable household",
    "disableConfirmTitle": "Disable {name}?",
    "disableConfirmBody": "Every member loses access immediately. Nothing is deleted, and you can undo this by restoring the household from this page.",
    "disableConfirmAction": "Disable household",
    "disabling": "Disabling…",
    "disableCancel": "Keep it active",
    "disableError": "The household could not be disabled. Try again.",
    "restoreAction": "Restore household",
    "restoring": "Restoring…",
    "restoreError": "The household could not be restored. Try again."
  },
  "accountDetail": {
    "balance": "Balance",
    "backToAccounts": "Back to accounts",
    "loading": "Loading account",
    "errorTitle": "The account could not be loaded",
    "errorBody": "Something went wrong while reading this account. Try again.",
    "retry": "Try again",
    "path": "Path",
    "ownCurrency": "Own currency",
    "viewInTransactions": "Open in transactions",
    "period": {
      "label": "Period",
      "month": "This month",
      "quarter": "Last 3 months",
      "year": "This year",
      "all": "All time"
    },
    "cards": {
      "entries": "Entries",
      "moneyIn": "Money in",
      "moneyOut": "Money out",
      "transfers": "Transfers",
      "transfersIn": "in",
      "transfersOut": "out",
      "adjustments": "Adjustments",
      "net": "Net",
      "income": "Income",
      "spending": "Spending"
    },
    "byPeriodTitle": "Net flow by period",
    "entriesTitle": "Entries",
    "entriesCountOne": "1 entry",
    "entriesCount": "{count} entries",
    "emptyTitle": "No entries in this period",
    "emptyBody": "Entries posted to this account in the selected period appear here.",
    "entriesErrorTitle": "The entries could not be loaded",
    "entriesErrorBody": "Something went wrong while reading this account's entries. Try again.",
    "loadMore": "Load more",
    "loadingMore": "Loading more",
    "endOfList": "That is every entry in this period.",
    "counterAccount": "Other side",
    "counterMore": "+{count} more",
    "internalMovement": "{from} → {to}",
    "internalNote": "Moves money between sub-accounts; the group total does not change",
    "internalNoteExchange": "Moves money between sub-accounts; the group total changes only by the exchange difference shown",
    "internalBetween": "Between {count} sub-accounts",
    "exchangeDifference": "Exchange difference",
    "currencyNote": "Amounts in {currency}",
    "subAccounts": {
      "totalsNote": "Totals include the sub-accounts",
      "ownEntriesNote": "This list shows only entries posted directly to this account, not to its sub-accounts.",
      "postableNote": "Postings can go to this account or to its sub-accounts."
    },
    "subtree": {
      "direct": "Directly to this account",
      "inSubAccounts": "In sub-accounts",
      "directSegment": "Directly to {name}",
      "spending": "Spending breakdown",
      "bySubAccount": "Breakdown by sub-account"
    }
  },
  "forgiveness": {
    "title": "Forgive this balance?",
    "consequence": "This writes off what {name} owes. It cannot be undone.",
    "currency": "Currency",
    "amount": "Amount to forgive",
    "amountRequired": "Enter an amount to forgive.",
    "amountTooLarge": "Cannot forgive more than what is owed.",
    "accountLabel": "Write off to",
    "error": "Could not forgive this balance.",
    "confirm": "Forgive",
    "cancel": "Cancel"
  }
}
